import { combineReducers } from 'redux'

// ACTIONS
export const CREATE = 'offerzen/projects/CREATE'
export const CREATE_SUCCESS = 'offerzen/projects/CREATE_SUCCESS'

export const FETCH = 'offerzen/projects/FETCH'
export const FETCH_SUCCESS = 'offerzen/projects/FETCH_SUCCESS'

export const UPDATE = 'offerzen/projects/UPDATE'
export const UPDATE_SUCCESS = 'offerzen/projects/UPDATE_SUCCESS'

export const UPDATE_PROGRESS = 'offerzen/projects/UPDATE_PROGRESS'

export const DELETE = 'offerzen/projects/DELETE'

export const TOGGLE_EDITING = 'offerzen/projects/TOGGLE_EDITING'

export const SET_PROJECT_TO_DELETE = 'offerzen/projects/SET_PROJECT_TO_DELETE'

// CREATE CREATORS
export const createProject = (id, data) => ({
  type: CREATE,
  payload: { id, data },
})

export const createProjectSuccess = data => ({
  type: CREATE_SUCCESS,
  payload: { ...data },
})

export const fetchProjects = id => ({
  type: FETCH,
  payload: { id },
})

export const fetchProjectSuccess = data => ({
  type: FETCH_SUCCESS,
  payload: [...data],
})

export const updateProject = (id, data) => ({
  type: UPDATE,
  payload: { id, data },
})

export const updateProjectSuccess = data => ({
  type: UPDATE_SUCCESS,
  payload: { ...data, editing: false },
})

export const deleteProject = (id, candidateId) => ({
  type: DELETE,
  payload: { id, candidateId },
})

export const toggleEditing = (id, editing) => ({
  type: TOGGLE_EDITING,
  payload: { id, editing },
})

export const updateProgress = data => ({
  type: UPDATE_PROGRESS,
  payload: { ...data },
})

export const setProjectToDelete = projectToDelete => ({
  type: SET_PROJECT_TO_DELETE,
  payload: { projectToDelete },
})

// REDUCERS
const initialState = {
  loading: false,
  fetched: true,
}

const project = (state = initialState, { type, payload }) => {
  // Can be refactored to simpler more generic actions
  switch (type) {
    case CREATE_SUCCESS:
    case UPDATE_SUCCESS:
    case TOGGLE_EDITING:
      if (state.id !== payload.id) state

      return {
        ...state,
        ...payload,
      }

    default:
      return {
        ...initialState,
        ...state,
      }
  }
}

const uploadProgress = (
  state = {
    progress: 0,
    isUploading: false,
    index: null,
  },
  action,
) => {
  switch (action.type) {
    case UPDATE_PROGRESS:
      return {
        ...state,
        ...action.payload,
      }

    default:
      return state
  }
}

const defaultProjects = {}

const entities = (state = defaultProjects, action) => {
  switch (action.type) {
    case FETCH_SUCCESS:
      return action.payload.reduce((projectMap, projectItem) => {
        projectMap[projectItem.id] = project(projectItem, action)
        return projectMap
      }, {})

    case CREATE_SUCCESS:
    case UPDATE_SUCCESS:
    case TOGGLE_EDITING:
      return {
        ...state,
        [action.payload.id]: project(state[action.payload.id], action),
      }

    default:
      return state
  }
}

const allIds = (state = [], action) => {
  switch (action.type) {
    case CREATE_SUCCESS:
      return [...state, action.payload.id]

    case FETCH_SUCCESS:
      return action.payload.map(project => project.id)

    default:
      return state
  }
}

const projectToDelete = (state = {}, action) => {
  switch (action.type) {
    case SET_PROJECT_TO_DELETE:
      return {
        ...state,
        ...action.payload.projectToDelete,
      }

    default:
      return state
  }
}

const projectsReducer = combineReducers({
  entities,
  ids: allIds,
  projectToDelete,
  uploadProgress,
})

export default projectsReducer

export const getProjects = state => state.views.profile.projects.entities || defaultProjects
